

















































































































































































import { Component } from 'vue-property-decorator';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import IconConstants from '@/lib/iconConstants';
import AddJobPlacementsToInvoiceRequest from '@/models/Invoices/AddJobPlacementsToInvoiceRequest';
import RemoveJobPlacementsFromInvoiceRequest from '@/models/Invoices/RemoveJobPlacementsFromInvoiceRequest';
import { AppModule } from '@/store/modules/app';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';

@Component({
  name: 'InvoiceJobPlacements',
})
export default class extends GiganautVue {

  activeTab = 0;
  selectedJobPlacements: JobWorkerOfferDto[] = [];
  selectedJobPlacementIds: string[] = [];
  selectedIncludedJobPlacements: JobWorkerOfferDto[] = [];
  selectedIncludedJobPlacementIds: string[] = [];

  private browseHeaders = [
    { text: "Title", value: 'job.title'},
    { text: "Desk", value: 'job.desk.name'},
    { text: this.Labels.location, value: 'job.location.brandName'},
    { text: this.Labels.worker, value: 'worker.person.lastName'},
    { text: 'Start Date', value: 'startDate'},
    { text: 'Fee', value: 'fee'},
    { text: 'Actions'},
  ];

  private includedHeaders = [
    { text: "Title", value: 'job.title'},
    { text: "Desk", value: 'job.desk.name'},
    { text: this.Labels.location, value: 'job.location.brandName'},
    { text: this.Labels.worker, value: 'worker.person.lastName'},
    { text: 'Start Date', value: 'startDate'},
    { text: 'Fee', value: 'fee'},
    { text: 'Actions'},
  ];

  get currentInvoice() {
    return InvoiceDetailsModule.currentInvoice;
  }

  get availableJobPlacements() {
    return InvoiceDetailsModule.availableJobPlacements;
  }

  get includedJobPlacements() {
    return InvoiceDetailsModule.includedJobPlacements;
  }

  get loadingJobPlacements() {
    return InvoiceDetailsModule.loadingJobPlacements;
  }

  get loadingIncludedJobPlacements() {
    return InvoiceDetailsModule.loadingIncludedJobPlacements;
  }

  get loadingDialog() {
    return InvoiceDetailsModule.loadingDialog;
  }

  async mounted() {
    console.log("InvoiceJobPlacements mounted");
    await this.loadAvailableJobPlacements();
    await this.loadIncludedJobPlacements();
  }

  toggleJobPlacementSelection(jobPlacementId: string, selected: boolean) {
    if (selected && !this.selectedJobPlacementIds.includes(jobPlacementId)) {
      this.selectedJobPlacementIds.push(jobPlacementId);
    } else if (!selected) {
      const index = this.selectedJobPlacementIds.indexOf(jobPlacementId);
      if (index > -1) {
        this.selectedJobPlacementIds.splice(index, 1);
      }
    }
  }

  updateSelectedJobPlacementIds(selectedItems: JobWorkerOfferDto[]) {
    this.selectedJobPlacementIds = selectedItems.map(item => item.id);
  }

  toggleIncludedJobPlacementSelection(jobPlacementId: string, selected: boolean) {
    if (selected && !this.selectedIncludedJobPlacementIds.includes(jobPlacementId)) {
      this.selectedIncludedJobPlacementIds.push(jobPlacementId);
    } else if (!selected) {
      const index = this.selectedIncludedJobPlacementIds.indexOf(jobPlacementId);
      if (index > -1) {
        this.selectedIncludedJobPlacementIds.splice(index, 1);
      }
    }
  }

  updateSelectedIncludedJobPlacementIds(selectedItems: JobWorkerOfferDto[]) {
    this.selectedIncludedJobPlacementIds = selectedItems.map(item => item.id);
  }

  async addSelectedJobPlacements() {
    if (!this.currentInvoice || !this.currentInvoice.id || this.selectedJobPlacementIds.length === 0) {
      return;
    }

    const request = new AddJobPlacementsToInvoiceRequest();
    request.jobPlacementIds = [...this.selectedJobPlacementIds];
    await InvoiceDetailsModule.addJobPlacementsToInvoice(request);
    
    // Clear selections and refresh both lists
    this.selectedJobPlacementIds = [];
    this.selectedJobPlacements = [];
    await this.loadAvailableJobPlacements();
    await this.loadIncludedJobPlacements();
  }

  async removeSelectedJobPlacements() {
    if (!this.currentInvoice || !this.currentInvoice.id || this.selectedIncludedJobPlacementIds.length === 0) {
      return;
    }

    const request = new RemoveJobPlacementsFromInvoiceRequest();
    request.jobPlacementIds = [...this.selectedIncludedJobPlacementIds];
    await InvoiceDetailsModule.removeJobPlacementsFromInvoice(request);
    
    // Clear selections and refresh both lists
    this.selectedIncludedJobPlacementIds = [];
    this.selectedIncludedJobPlacements = [];
    await this.loadAvailableJobPlacements();
    await this.loadIncludedJobPlacements();
  }

  async refreshAvailableJobPlacements() {
    await this.loadAvailableJobPlacements();
  }

  async refreshIncludedJobPlacements() {
    await this.loadIncludedJobPlacements();
  }

  async loadAvailableJobPlacements() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      return;
    }

    await InvoiceDetailsModule.getAvailableJobPlacements();
  }

  async loadIncludedJobPlacements() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      return;
    }

    await InvoiceDetailsModule.getIncludedJobPlacements();
  }
}
